/**
 * Promise.race-style timeout for Firestore get(), fetch, etc.
 * Rejecting does not cancel the underlying work.
 */
export function withTimeoutMs(promise, ms) {
  return new Promise((resolve, reject) => {
    const t = window.setTimeout(() => reject(new Error('timeout')), ms);
    Promise.resolve(promise).then(
      (v) => {
        window.clearTimeout(t);
        resolve(v);
      },
      (e) => {
        window.clearTimeout(t);
        reject(e);
      }
    );
  });
}
